export const Get_ALL_QUOTATIONS = "Get_ALL_QUOTATIONS";
export const API_CALL_STATUS = "API_CALL_STATUS"
export const IS_QUATATION_LIST = "IS_QUATATION_LIST"
export const QUOTATION_ITEM_DETAILS = 'QUOTATION_ITEM_DETAILS'
export const CLEAR_MESSAGESS = 'CLEAR_MESSAGESS'
export const QUOTATION_REMARKS = 'QUOTATION_REMARKS'